
import React from "react";
import { Loader2 } from "lucide-react";

export const LoadingEvents = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 className="h-12 w-12 text-neon-green animate-spin mb-4" />
      <p className="text-black">Loading events...</p>
    </div>
  );
};
